// src/ui/FlightPreview.jsx — the strip above the composer.
//
// It appears while you're still typing, and its only job is to answer "am I about to
// send a flight card, and is it the right flight?" before you commit. It is NOT a gate:
// hitting Enter before this resolves still sends the card (ChatWindow.doSend), which is
// the whole point — the preview is a courtesy, never a dependency.
//
// The ✕ is the escape hatch. Some messages genuinely are just "BA 220 is the code" and
// deserve to stay text; dismissing remembers that number for the rest of the chat.

import React from 'react';
import { Plane, X } from './icons';
import { statusColor, statusLabel, flightTime, airlineName } from '../services/flights';

export default function FlightPreview({ detection, data, busy, failed, onDismiss }) {
  if (!detection) return null;
  const color = data ? statusColor(data.status) : 'var(--text-3)';
  const name = data?.airline || detection.airline || airlineName(detection.code) || 'Flight';

  return (
    <div className="fp" style={{ borderLeftColor: data ? color : 'var(--text-3)' }}>
      <span className="fp-ico" style={{ color: data ? color : 'var(--text-3)' }}>
        <Plane width={18} height={18} />
      </span>

      <span className="fp-body">
        <span className="fp-line1">
          {name} <b>{data?.flightNumber || detection.canonical}</b>
        </span>
        <span className="fp-line2">
          {busy && 'Looking up flight…'}
          {!busy && data && (
            <>
              <b>{data.origin?.code}</b>
              <Plane width={12} height={12} className="fp-arrow" />
              <b>{data.destination?.code}</b>
              <span className="fp-sep">·</span>
              {flightTime(data.origin?.time)}
              <span className="fp-sep">·</span>
              <span style={{ color }}>{statusLabel(data.status)}</span>
            </>
          )}
          {/* 🟢 "no live data" is not a failure message — the card still sends, and
              it fills itself in the moment the service answers again. */}
          {!busy && !data && (failed ? 'No live data — it will still send as a flight card' : 'Ready to send as a flight card')}
        </span>
      </span>

      <button className="fp-x" title="Send as plain text instead" onClick={onDismiss}>
        <X width={15} height={15} />
      </button>
    </div>
  );
}
